// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getCardWidth,
  getCardHeight,
} from 'app/common/react/components/profile/ProfileBoardCard/layout';
import { Box, Mask, Image } from 'gestalt';

type Props = {|
  boardName: string,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  boardThumbs: Array<*>,
  coverImagePos: {
    height: number,
    width: number,
    x: number,
    y: number,
  },
  coverImageUrl: string,
  coverImageWidth?: number,
  customCover?: boolean,
  isInvite?: boolean,
|};

// Amount of pixels between items
const SPACING = 2;

//eslint-disable-next-line react/prefer-stateless-function
export default class SquareBoardCollage extends Component<Props> {
  render() {
    const { boardThumbs = [], coverImagePos, coverImageUrl, isInvite } = this.props;
    const width = getCardWidth('square', isInvite);
    const height = getCardHeight('square', isInvite);
    const hasCoverImage = coverImagePos && coverImageUrl && coverImageUrl !== '';
    const thumbWidth = width / 2 - SPACING / 2;
    const thumbHeight = height / 2 - SPACING / 2;
    const thumbs = [
      ...boardThumbs.slice(0, hasCoverImage ? 3 : 4),
      ...[...new Array(4).fill({ url: '' })],
    ].slice(0, hasCoverImage ? 3 : 4);

    return (
      <Mask shape="rounded" width={width} height={height}>
        <Box display="flex" wrap>
          {hasCoverImage && (
            <Box
              dangerouslySetInlineStyle={{
                __style: {
                  marginBottom: SPACING,
                  marginRight: SPACING,
                },
              }}
            >
              <Mask wash height={thumbHeight} width={thumbWidth}>
                <Image
                  alt=""
                  src={coverImageUrl}
                  color={'#EFEFEF'}
                  naturalWidth={coverImagePos.width || 1}
                  naturalHeight={coverImagePos.height || 1}
                  fit="cover"
                />
              </Mask>
            </Box>
          )}
          {thumbs.map((thumb, index) => (
            <Box
              dangerouslySetInlineStyle={{
                __style: {
                  marginBottom: index === 0 || (!hasCoverImage && index === 1) ? SPACING : 0,
                  marginRight:
                    (!hasCoverImage && (index === 0 || index === 2)) ||
                    (hasCoverImage && index === 1)
                      ? SPACING
                      : 0,
                },
              }}
              key={index}
            >
              {thumb && thumb.url !== '' ? (
                <Mask wash height={thumbHeight} width={thumbWidth} key={index}>
                  <Image
                    alt=""
                    src={thumb.url || ''}
                    color={thumb.dominant_color || '#EFEFEF'}
                    naturalWidth={thumb.width || 1}
                    naturalHeight={thumb.height || 1}
                    fit="cover"
                  />
                </Mask>
              ) : (
                <Box color="lightGray" key={index} width={thumbWidth} height={thumbHeight} />
              )}
            </Box>
          ))}
        </Box>
      </Mask>
    );
  }
}

SquareBoardCollage.propTypes = {
  boardName: PropTypes.string,
  boardThumbs: PropTypes.arrayOf(
    PropTypes.shape({
      dominant_color: PropTypes.string,
      height: PropTypes.number,
      url: PropTypes.string,
      width: PropTypes.number,
    }),
  ),
  coverImagePos: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  coverImageUrl: PropTypes.string,
};
